module.exports = __webpack_public_path__ + "img/alpha5.7d215c6e.png";